require('./paid-introduction.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')
require('../components/payment/payment-module')

# Load Css
require('../../../sass/web/html/_paid_introduction.scss')

PaidIntroductionCtrl = require('./paid-introduction-controller')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-payment'
]
angular.module 'gnp-app-paid-introduction', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/paid-introduction',
      templateUrl: 'web/paid-introduction/paid-introduction.jade'
      controller: 'PaidIntroductionCtrl'
      title: '_PAID_INTRO.PAGE_TITLE'
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
    .translations 'en', require('./i18n/en')
    .translations 'ja', require('./i18n/ja')
  ]
  .controller 'PaidIntroductionCtrl', PaidIntroductionCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/paid-introduction/paid-introduction-module.coffee